<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.audioPlayTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放
        </el-col>
        <el-col :span="24" class="imgStyle" :style="{'height':heart.questionDto.detailInfo.audioUrl?'calc( 100% - 55px )':''}" align="left">
            <!-- 单选 选项为空 -->
            <!-- <div class="advancedOptions" v-show="radioMode">
                <img class="imgStyleUrl" v-if="heart.questionDto.detailInfo.questionImgUrl" v-viewer :src="heart.questionDto.detailInfo.questionImgUrl" alt="" srcset="">
                <div style="clear: both;"></div>
                <div class="styleCent" v-for="(item,i) in heart.questionDto.detailInfo.detailsList" :key="i">
                    <el-checkbox-group v-model="advancedRadio" class="opRadio" size="medium">
                        <el-checkbox :label="item.bId">&nbsp;</el-checkbox>
                    </el-checkbox-group>
                    <div class="options_A" @click="advancedRadio=item.bId">{{item.msg.substr(0, 1)}}</div>
                </div>
            </div> -->
            <!-- 单选 选项非空 -->
            <div class="optionsHaveValue">
                <div class="imgStyleFath">
                    <img class="imgStyleUrl" v-if="heart.questionDto.detailInfo.questionImgUrl" v-viewer :src="heart.questionDto.detailInfo.questionImgUrl" alt="" srcset="">
                </div>
                <div class="optonList clear" ref="optonListRef">
                    <div class="styleCent" v-for="(item,i) in heart.questionDto.detailInfo.detailsList" :key="i" :ref="'questionCent'+i" :style="{'width':typeSetting==2?'50%':''}">
                        <el-checkbox-group v-model="advancedRadio" class="opRadio" size="medium">
                            <el-checkbox :label="item.bId">&nbsp;</el-checkbox>
                        </el-checkbox-group>
                        <div class="options_A textAlign" @click="addAdRadio(item.bId)" v-html="item.msg">{{item.msg}}</div>
                    </div>
                </div>
            </div>
        </el-col>
    </div>
</template>
<script>
import audioStyle from '../../components/audioStyle'
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"multipleChoice",
        props: {
            sonData: Object,
            allAnswer: Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                rhythmBeatVal:[],
                timeHer:'',
                advancedRadio:[],
                double_advancedRadio:'',
                radioMode:true,
                plays:0,
                answerType:null,
                typeSetting:1,
            }
        },
        components:{
            audioStyle
        },
        watch: {
            'advancedRadio':function(now,old){
                let b = utils.deepClone2(now)
                this.double_advancedRadio = b.join()
                if(this.double_advancedRadio&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
                this.$nextTick(()=>{
                    wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                        allData:this.$parent.allData,
                        uuid1:this.$parent.uuid1,
                        firstStartDateVal:this.$parent.firstStartDateVal,
                    })
                })
            },
            'plays':function(now,old){
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            }
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                this.rhythmBeatVal = []
                this.plays = utils.mottoClone(this.heart.audioPlayTime)
                let heartDto = this.heart.questionDto.detailInfo.detailsList
                let fleg = true
                heartDto.forEach((ele,i) => {
                    if(ele.msg){
                        fleg=false
                        ele.msg = utils.letter26To(i) +'、'+ utils.dealText(ele.msg)
                    }else{ele.msg = utils.letter26To(i)}
                });
                if(!fleg) this.radioMode=false

                // 赋值答案
                if(this.allAnswer){
                    if(this.allAnswer.obj.selectIds){
                        let bv = utils.deepClone2(this.allAnswer.obj.selectIds)
                        this.advancedRadio = bv.split(',').map(Number)
                    }
                    this.answerType = this.allAnswer.obj.answerType
                    this.plays = this.allAnswer.playss
                }

                // 计算 一排展示还是两排展示
                this.computationalArrangement()
            })
        },
        methods:{
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.audioPlayTime)
            },
            startPlaying(){
                
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
            },
            yesNotProblem(){
                if(this.advancedRadio.length>0) return true
                return false
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },
            blea(s){
                return s==0? 'A、':s==1? 'B、':s==2? 'C、':s==3? 'D、':''
            },
            addAdRadio(bId){
                if(this.advancedRadio.indexOf(bId)!=-1){
                    this.advancedRadio.splice(this.advancedRadio.indexOf(bId), 1)
                }else{
                    this.advancedRadio.push(bId)
                }
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            },
            computationalArrangement(){
                let that = this
                that.$nextTick(()=>{
                    timrT5 && window.clearTimeout(timrT5)
                    let timrT5 = window.setTimeout(function(){
                        const boxEle = that.$refs.optonListRef
                        const boxChild0 = eval(`that.$refs.questionCent0`)[0]
                        const boxChild0H = Number(boxChild0.offsetHeight) + Number((getComputedStyle(boxChild0).marginTop).replace('px','')) + Number((getComputedStyle(boxChild0).marginBottom).replace('px',''))
                        const holdNum = Math.floor(boxEle.offsetHeight / boxChild0H)
                        that.typeSetting = that.heart.questionDto.detailInfo.detailsList.length <= holdNum?1:2
                        that.$nextTick(()=>{
                            for (let i = 0; i < that.heart.questionDto.detailInfo.detailsList.length; i++) {
                                if(i % 2 != 0 && eval(`that.$refs.questionCent${i-1}`)[0].offsetHeight != eval(`that.$refs.questionCent${i}`)[0].offsetHeight){
                                    eval(`that.$refs.questionCent${eval(`that.$refs.questionCent${i-1}`)[0].offsetHeight>eval(`that.$refs.questionCent${i}`)[0].offsetHeight?i:i-1}`)[0].getElementsByClassName('options_A')[0].style.display = 'flex'
                                    eval(`that.$refs.questionCent${eval(`that.$refs.questionCent${i-1}`)[0].offsetHeight>eval(`that.$refs.questionCent${i}`)[0].offsetHeight?i:i-1}`)[0].getElementsByClassName('options_A')[0].style.alignItems = 'center'
                                    eval(`that.$refs.questionCent${eval(`that.$refs.questionCent${i-1}`)[0].offsetHeight>eval(`that.$refs.questionCent${i}`)[0].offsetHeight?i:i-1}`)[0].getElementsByClassName('options_A')[0].style.height = Math.max(eval(`that.$refs.questionCent${i-1}`)[0].offsetHeight,eval(`that.$refs.questionCent${i}`)[0].offsetHeight) +'px'
                                }
                            }
                        })
                        window.clearTimeout(timrT5)
                    },350)
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 5px 0px 5px 18px;
            overflow-y: auto;
            // 图片单选 选项为空
            .advancedOptions{
                height: 100%;
                .imgStyleUrl{
                    height: 25%;
                    max-width: 85%;
                }
                .styleCent{
                    width: 20%;
                    float: left;
                    margin: 0 2.5%;
                    .opRadio{
                        width: 10%;
                        height: 60px;
                        line-height: 60px;
                        text-align: end;
                        float: left;
                        margin-right: 0;
                    }
                    .options_A{
                        width: 90%;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        background-image: url('../../../static/images/opt.png');
                        background-size: 100% 100%;
                        background-position: 0px 0;
                        float: left;
                    }
                    .opRadio_active{background-image: url('../../../static/images/zhongOpt.png');}
                    .options_A:active{
                        background-image: url('../../../static/images/zhongOpt.png');
                    }
                }
            }
            // 图片单选 选项非为空
            .optionsHaveValue{
                height: 100%;
                display: flex;
                flex-direction: column;
                overflow: hidden;
                .imgStyleFath{
                    width: 100%;
                    max-height: 25%;
                    .imgStyleUrl{
                        height: 100%;
                        max-width: 85%;
                    }
                }
                .optonList{
                    flex-grow: 1; /* 占据剩余高度 */
                    width: 100%;
                    overflow-y: auto;
                    box-sizing: border-box;
                    border-top: 5px solid transparent;
                    .styleCent{
                        float: left;
                        width: 100%;
                        margin: 0 0%;
                        min-height: 50px;
                        box-sizing: border-box;
                        margin: 10px 0;
                        display: flex;
                        align-items: center;
                        .opRadio{
                            width: 40px;
                            height: 100%;
                            text-align: end;
                            float: left;
                            margin-right: 0;
                        }
                        .options_A{
                            width: calc( 100% - 60px );
                            margin-left: 10px;
                            box-shadow: 0px 0px 6px 2px #E9F4FF;
                            border: 1px solid #E9F4FF;
                            border-radius: 5px;
                            float: left;
                        }
                        .opRadio_active{background-image: url('../../../static/images/zhongOpt.png');}
                        .options_A:active{
                            border-color: #004BB4;
                        }
                        .textAlign{
                            text-align: left;
                            box-sizing: border-box;
                            padding: 12.5px;
                        }
                    }
                }
            }
        }
    }
</style>
<style>
    .styleCent .el-radio__inner{
        height: 18px;
        width: 18px;
    }
    .textAlign .tableimg{
        height: 37px;
        max-height: 37px !important;
        /* width: 80% !important; */
        /* position: relative; */
        margin: 0 5px;
        display: inline-block;
        vertical-align: middle;
    }
    .textAlign .tableimg img{
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        /* max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0; */
        /* right: 0; */
        /* bottom: 0;
        left: 0;
        display: block;
        margin: auto 0; */
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/multipleChoice.vue